import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { SettingsService } from "../services/settings.service";
import { CreateAdminDto, UpdateAdminDto } from "../dto/index.dto";
import { DEFAULT_LIMIT } from "../../../shared/dto/pagination.dto";

export const useGetAdminsHook = (
  page: number,
  limit: number = DEFAULT_LIMIT
) => {
  return useQuery({
    queryKey: ["admins", page, limit],
    queryFn: () => SettingsService.getAdmins(page, limit),
    placeholderData: keepPreviousData,
  });
};

export const useCreateAdminHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAdminDto) => SettingsService.createAdmin(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admins"] }),
  });
};

export const useUpdateAdminHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateAdminDto }) =>
      SettingsService.updateAdmin(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admins"] }),
  });
};

export const useDeleteAdminHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => SettingsService.deleteAdmin(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admins"] }),
  });
};
